export const WORKER_BASE_URL = 'https://zitieapi.tgmediaorganizer.app'
